// extracted by mini-css-extract-plugin
module.exports = {"container":"CountryDownloadBox__container","WISHLIST":"CountryDownloadBox__WISHLIST","downloadLinks":"CountryDownloadBox__downloadLinks"};